import Link from 'next/link'
import { Avatar, AvatarFallback } from '~/src/components/ui/avatar'
import useUserData from '~/src/hooks/useUserData'

const UserInitials = () => {
  const { initials } = useUserData()

  if (!initials) return null

  return (
    <Link href='/profile'>
      <Avatar className='h-8 w-8 md:h-9 md:w-9'>
        <AvatarFallback className='text-sm font-medium'>
          {initials}
        </AvatarFallback>
      </Avatar>
    </Link>
  )
}

export default UserInitials
